import React, { useState, useEffect, Suspense, lazy, useMemo } from "react";
import "../css/index.scss";
import "../css/rankTracking.css";
import "../css/loader.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  DOMAINOVERVIEW_GET,
  GET_SITE_AUDIT,
  delete_Project,
  get_backlink_data,
  get_backlinktotallmtGet,
  get_domainauthority,
  post_backlink_data,
  post_backlinktotallmt,
  post_user_backlinklimit,
  update_backlinktotallmtupdate,
} from "../../services/constants";
import AreYousure from "../share/card-layout/AreYousure";
import { useNavigate, Link } from "react-router-dom";
import { Store } from "../../Affiliate/utils/STORE";
import { ReactComponent as RankIcon } from "../Assets/home/keyword-rank-icon.svg";
import BlurCard from "../share/card-layout/blur-card";
import { Player } from "@lottiefiles/react-lottie-player";
import spinLoaderAnimation from "../Assets/spin-loader.json";

import { ZustandStore } from "../../store/zustand-store";
import countryList from "../dataFiles/country";
import useDebouncedFunction from "../../helperJs/debounce";
import {
  formatNumberWithSymbols,
  handleNaNAndUndefined,
  removeUndefinedAndNaN,
} from "../../helperJs/helper";
import RankTable from "../../helperJs/rank-table";
import MapTable from "../../helperJs/map-table";
import AITrackerTable from "../../helperJs/AITracker-table";
import { monthNameArr } from "../share/upDater/constant";
import Spinner from "../share/components/spinner";
import { useTranslation } from "react-i18next";
import ProjectList from "../share/dropdown-menu/ProjectList";
import PieChartForRank from "../share/d3-charts/PieChartForRank";

import DeleteIcon from "@mui/icons-material/Delete";
import SemButton from "../../common/components/Button";
import AddProject from "../share/components/add-project-section/rank-tracker/AddProject";
import NegativeStackedBarChart from "../share/d3-charts/NegativeStackedBarChart";
import ChartWrapper from "../share/d3-charts/ChartWrapper";
import { chartType } from "../share/d3-charts/helper";
import GroupedBarsChart from "../share/d3-charts/GroupedBarsChart";
import LineChart from "../share/d3-charts/LineChart";

const DashboardGoogleData = lazy(() =>
  import("./google-data/dashboard-google-data")
);

export const Home = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user_type = localStorage.getItem("user_type");
  const Is_organization = user_type === "organization";
  const months = monthNameArr;

  // start *updating rank table and keyword data
  RankTable();
  MapTable();
  AITrackerTable();
  // end *updating rank table and keyword data

  const email = useSelector((state) => state.email);
  const showLoader = useSelector((state) => state.showloader);
  // const websiteurl = useSelector((state) => state.websiteurl);
  const RankMovedup = useSelector((state) => state.rankmovedup);
  const backlinklimits = useSelector((state) => state.backlinkLimit);
  const RankMovedDown = useSelector((state) => state.rankmoveddown);
  // usercurrentlocation get index 0 for siteoverview data
  const usercurrentprojectlocation = useSelector(
    (state) => state.usercurrentprojectlocation
  );
  const userselectedprojectallid = useSelector(
    (state) => state.userselectedprojectallid
  );

  const { RankDownPercent } = Store((state) => state);
  const {
    selected_domain,
    site_overview_data,
    backlink_data_hm,
    domain_auth_hm,
    site_audit_hm,
    country_Language_Data,
    emptyKeywordData,
    emptyAllLocData,
    customer_plan,
  } = ZustandStore((state) => state);

  const [hasCalledApi, setHasCalledApi] = useState(false);

  const [siteOverviewData, setSiteOverviewData] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [backlinkData, setBacklinkData] = useState({
    data: [],
    loading: true,
    error: null,
  });

  const [auditLoader, setAuditLoader] = useState(true);
  const [auditData, setAuditData] = useState([]);

  const [Seo_descovered, setSeo_Descovered] = useState();
  const [domainAuthority, setDomainAuthority] = useState();
  const [deleteAlert, setdeleteAlert] = useState(false);

  const postBacklinkLimit = (data) => {
    if (usercurrentprojectlocation?.length === 0) return;
    const curr_proj = usercurrentprojectlocation?.[0];
    const domain = curr_proj?.weburl;
    let post_config = {
      email: email,
      domain_name: domain,
      bakclinklmt: data?.length,
    };
    const rowLmt = backlinklimits?.backlinks_rows_limit;
    axios.post(post_user_backlinklimit(), post_config);
    axios.get(get_backlinktotallmtGet(email)).then((response) => {
      if (response.data?.length > 0) {
        axios.put(
          update_backlinktotallmtupdate(
            response?.data[response?.data?.length - 1].id
          ),
          {
            email: email,
            backlinktotallmt:
              response?.data[response?.data?.length - 1].backlinktotallmt -
              data?.length,
          }
        );
      } else if (response.data?.length === 0) {
        axios.post(post_backlinktotallmt(), {
          email: email,
          backlinktotallmt: rowLmt - data?.length,
        });
      }
    });
  };

  const fetchBacklinkData = async () => {
    if (usercurrentprojectlocation?.length === 0) return;
    const curr_proj = usercurrentprojectlocation?.[0];
    const domain = curr_proj?.weburl;
    const config = {
      email: email,
      domain: domain,
      include_subdomains: true,
    };
    if (
      config?.domain === "" ||
      config?.domain === undefined ||
      config?.domain === null
    )
      return;
    if (
      selected_domain === domain &&
      backlink_data_hm?.length != 0 &&
      domain_auth_hm?.length != 0
    ) {
      setDomainAuthority(domain_auth_hm);
      setBacklinkData({
        data: backlink_data_hm,
        loading: false,
        error: false,
      });
    } else {
      setBacklinkData({
        data: [],
        loading: true,
        error: false,
      });

      await axios.get(get_domainauthority(config.domain)).then((response) => {
        setDomainAuthority(response.data);
        ZustandStore.setState({
          domain_auth_hm: response.data,
        });
      });
      axios.get(get_backlink_data(config)).then((response) => {
        if (response.data?.length > 0) {
          const data = response.data?.[0];
          setBacklinkData({
            data: data,
            loading: false,
            error: false,
          });
          ZustandStore.setState({
            backlink_data_hm: data,
          });
        } else {
          axios
            .get(get_backlinktotallmtGet(email))
            .then((response) => {
              const userLmt =
                response.data[response.data?.length - 1]?.backlinktotallmt;
              if (response.data?.length > 0) {
                if (userLmt <= 0) {
                  setBacklinkData({
                    data: [],
                    loading: false,
                    error: false,
                  });
                  ZustandStore.setState({
                    backlink_data_hm: [],
                  });
                  return;
                }
              }
              axios
                .post(post_backlink_data(config))
                .then((response) => {
                  if (response.data?.length === 0) {
                    setBacklinkData({
                      data: [],
                      loading: false,
                      error: false,
                    });
                    ZustandStore.setState({
                      backlink_data_hm: [],
                    });
                  } else {
                    setBacklinkData({
                      data: response.data[0],
                      loading: false,
                      error: false,
                    });
                    const backlink_data = response.data[0]?.data;
                    postBacklinkLimit(backlink_data, response.data);
                    ZustandStore.setState({
                      backlink_data_hm: response.data[0],
                    });
                  }
                })
                .catch(() => {
                  setBacklinkData({
                    data: [],
                    loading: false,
                    error: false,
                  });
                  ZustandStore.setState({
                    backlink_data_hm: [],
                  });
                });
            })
            .catch(() => {
              setBacklinkData({
                data: [],
                loading: false,
                error: false,
              });
              ZustandStore.setState({
                backlink_data_hm: [],
              });
            });
        }
      });
    }
  };

  const fetchSiteOverviewData = (config) => {
    if (
      config?.domain === "" ||
      config?.domain === undefined ||
      config?.domain === null
    )
      return;
    if (selected_domain === config?.domain && site_overview_data?.length != 0) {
      setSiteOverviewData({
        data: site_overview_data,
        loading: false,
        error: false,
      });
    } else {
      setSiteOverviewData({
        data: [],
        loading: true,
        error: false,
      });

      const json_getDomain = {
        domainName: config?.domain,
        domainCountry: config?.loc_name,
        domainLanuage: config.language_name,
      };

      ZustandStore.setState({
        selected_domain: config?.domain,
      });

      axios(DOMAINOVERVIEW_GET(json_getDomain))
        .then((res) => {
          if (res.data.length !== 0) {
            const data = res.data[0];
            setSiteOverviewData({
              data: data,
              loading: false,
              error: false,
            });
            ZustandStore.setState({
              site_overview_data: data,
            });
          } else {
            setSiteOverviewData({
              data: [],
              loading: false,
              error: false,
            });
            ZustandStore.setState({
              selected_domain: "",
              site_overview_data: [],
            });
          }
        })
        .catch(() => {
          setSiteOverviewData({
            data: [],
            loading: false,
            error: true,
          });
          ZustandStore.setState({
            selected_domain: "",
            site_overview_data: [],
          });
        });
    }
  };

  const debouncedProjectFunction = useDebouncedFunction(() => {
    if (usercurrentprojectlocation?.length > 0 && !hasCalledApi) {
      setHasCalledApi(true); // Set the state to true after the API calls
      const curr_proj = usercurrentprojectlocation?.[0];
      const lastString = curr_proj?.location_name.split(",").pop(); // "India"
      const country = country_Language_Data?.data?.filter((country) => {
        return (
          country.location_name === lastString &&
          country?.location_type === "Country"
        );
      });

      const config = {
        domain: curr_proj?.weburl,
        loc_name: country ? country?.[0]?.location_name : "United States",
        loc_code: country ? country?.[0]?.location_code : 2840,
        loc_flag: country
          ? country?.[0]?.flag
          : "https://flagsapi.com/US/flat/24.png",
        language_name: country
          ? country?.[0]?.available_languages?.[0]?.language_name
          : "English",
        language_code: country
          ? country?.[0]?.available_languages?.[0]?.language_code
          : "en",
      };

      fetchSiteOverviewData(config);
      fetchBacklinkData();
      siteAuditData();
    }
  }, 100); // debounce delay

  const siteAuditData = () => {
    if (usercurrentprojectlocation?.length === 0) return;
    const curr_proj = usercurrentprojectlocation?.[0];
    const config = {
      domain: curr_proj?.weburl || "",
      loc_name: curr_proj?.location_name || "",
      loc_code: curr_proj?.location_code || "",
    };
    if (
      config?.domain === "" ||
      config?.domain === undefined ||
      config?.domain === null
    )
      return;

    const item = {
      email: email,
      domain: curr_proj?.weburl,
      max_crawl_page: customer_plan?.site_check_limit || 0,
    };

    ZustandStore.setState({
      selected_domain: item?.domain,
    });

    if (selected_domain === item?.domain && site_audit_hm?.length != 0) {
      setAuditData(site_audit_hm);
      setAuditLoader(false);
    } else {
      setAuditData([]);
      setAuditLoader(true);
      setSeo_Descovered();
      axios
        .get(GET_SITE_AUDIT(item))
        .then((response) => {
          const audit_data = response.data;
          if (audit_data.length !== 0) {
            setAuditData(audit_data[audit_data.length - 1]?.data?.[0]?.result);
            setAuditLoader(false);
            const queueDataValue =
              audit_data[audit_data.length - 1]?.data[0]?.result[0]
                ?.crawl_status.pages_in_queue || 0;

            if (queueDataValue === 0) {
              ZustandStore.setState({
                site_audit_hm:
                  audit_data[audit_data.length - 1]?.data?.[0]?.result,
              });
            }
          } else {
            setAuditData([]);
            setSeo_Descovered();
            setAuditLoader(false);
            ZustandStore.setState({
              site_audit_hm: [],
            });
          }
        })
        .catch(() => {
          setAuditData([]);
          setAuditLoader(false);
          setSeo_Descovered();
        });
    }
  };

  useEffect(() => {
    // Reset the state if dependencies change to the initial state
    if (usercurrentprojectlocation?.length === 0) {
      setHasCalledApi(false);
    }
    debouncedProjectFunction();
  }, [usercurrentprojectlocation, hasCalledApi, debouncedProjectFunction]);

  const Do_Project_Delete = (res) => {
    if (res) {
      axios.delete(delete_Project(userselectedprojectallid[0])).then(() => {
        sessionStorage.removeItem("LAST_PRPJECT_SELECTED");
        setdeleteAlert(false);
        dispatch({
          type: "USERALLPROJECTDETAILS",
          payload: [],
        });
        emptyKeywordData();
        emptyAllLocData();
        dispatch({ type: "WEBSITEURL", payload: null });
        dispatch({ type: "CURRENTLOCATIONCODE", payload: null });
        dispatch({ type: "CURRENTLOCATION", payload: null });
      });
    } else {
      setdeleteAlert(false);
    }
  };

  useEffect(() => {
    if (auditData.length !== 0) {
      let resource_type_html = 0;
      let resource_type_redirect = 0;
      let resource_type_broken = 0;
      let resource_type_block = 0;
      let low_word_count = [];
      let dup_meta_desc = [];
      let dup_title_tag = [];
      let no_title_Tags = [];
      let with_h1 = [];
      let with_broken = [];
      let without_meta = [];
      let with_title_too = [];
      let with_title_short = [];
      let poorly_format = [];
      let doc_not_decl = [];
      let long_load_time = [];
      let url_long = [];
      let short_desc = [];
      let long_desc = [];
      let duplicate_h1_tags = [];
      let same_h1_and_title_tags = [];
      let conanical_issue = [];
      let no_favicon = [];
      let no_image_alt = [];
      let no_image_title = [];

      auditData[0]?.items &&
        auditData[0]?.items?.forEach((res) => {
          if (res.resource_type === "html") {
            resource_type_html += 1;

            // long description
            if (res?.meta?.description_length > 165) {
              long_desc.push({
                url: res?.url || "undefined",
                title: res?.meta?.title,
                desc: res?.meta?.description || "undefined",
                length: res?.meta?.description_length,
                status_code: res?.status_code,
              });
            }
            // short description
            if (res?.meta?.description_length < 150) {
              short_desc.push({
                url: res?.url || "undefined",
                title: res?.meta?.title,
                desc: res?.meta?.description || "undefined",
                length: res?.meta?.description_length,
                status_code: res?.status_code,
              });
            }

            // duplicate H1 tag
            if (res?.meta?.htags) {
              const h1Tags = res?.meta?.htags?.h1;
              // Check the number of h1 tags
              if (h1Tags?.length > 1) {
                duplicate_h1_tags.push({
                  url: res?.url || "undefined",
                  title: res?.meta?.title,
                  no_of_h1_tags: h1Tags?.length,
                  status_code: res?.status_code,
                });
              }
            }

            // same H1 and title tags
            if (res?.meta?.htags) {
              const h1Tags = res?.meta?.htags?.h1;
              const title = res?.meta?.title;
              // Check the number of h1 tags
              if (h1Tags?.includes(title)) {
                same_h1_and_title_tags.push({
                  url: res?.url || "undefined",
                  title: res?.meta?.title || "",
                  h1_tags: title || "",
                  status_code: res?.status_code,
                });
              }
            }

            // conanical issue
            if (!res?.checks?.canonical) {
              conanical_issue.push({
                url: res?.url || "undefined",
                title: res?.meta?.title,
                status_code: res?.status_code,
              });
            }

            // no favicons found
            if (res?.checks?.no_favicon) {
              no_favicon.push({
                url: res?.url || "undefined",
                title: res?.meta?.title,
                status_code: res?.status_code,
              });
            }

            // no favicons found
            if (res?.checks?.no_image_alt) {
              no_image_alt.push({
                url: res?.url || "undefined",
                title: res?.meta?.title,
                status_code: res?.status_code,
              });
            }
            // no image title found
            if (res?.checks?.no_image_title) {
              no_image_title.push({
                url: res?.url || "undefined",
                title: res?.meta?.title,
                status_code: res?.status_code,
              });
            }

            // set low word count
            if (res?.meta?.content?.plain_text_word_count < 200) {
              low_word_count.push({
                url: res.meta.canonical || "undefined",
                title: res.meta.title,
                count: res.meta.content.plain_text_word_count || "undefined",
                status_code: res?.status_code,
              });
            }

            if (res.duplicate_description === true) {
              dup_meta_desc.push({
                url: res.url || "undefined",
                title: res.meta.title,
                desc: res.meta.description || "undefined",
              });
            }

            if (res.checks.duplicate_title_tag === true) {
              dup_title_tag.push({
                url: res.url || "undefined",
                title: res.meta.title || "undefined",
              });
            }

            if (res.checks.no_title === true) {
              no_title_Tags.push({
                url: res.url || "undefined",
                title: res.meta.title,
              });
            }

            if (res.checks.no_h1_tag === true) {
              with_h1.push({
                url: res.url || "undefined",
                title: res.meta.title,
              });
            }

            if (res.checks.is_broken === true) {
              with_broken.push({
                url: res.url || "undefined",
                title: res.meta.title,
              });
            }

            if (res.checks.no_description === true) {
              without_meta.push({
                url: res.url || "undefined",
                title: res.meta.title,
              });
            }
            if (res.checks.title_too_long === true) {
              with_title_too.push({
                url: res.url || "undefined",
                title: res.meta.title || "undefined",
                length: res?.meta?.title_length,
                status_code: res?.status_code,
              });
            }
            if (res.checks.title_too_short === true) {
              with_title_short.push({
                url: res.url || "undefined",
                title: res.meta.title || "undefined",
                length: res?.meta?.title_length,
                status_code: res?.status_code,
              });
            }
            if (res.checks.seo_friendly_url === false) {
              poorly_format.push({
                url: res.url || "undefined",
                status_code: res?.status_code,
                characters:
                  res.checks.seo_friendly_url_characters_check || "undefined",
                dynamic:
                  res.checks.seo_friendly_url_dynamic_check || "undefined",
                keywords:
                  res.checks.seo_friendly_url_keywords_check || "undefined",
                title: res.meta.title,
              });
            }
            if (res.checks.no_doctype === true) {
              doc_not_decl.push({
                url: res.url || "undefined",
                title: res.meta.title,
              });
            }
            if (res?.checks?.high_loading_time === true) {
              const seconds = res?.page_timing?.duration_time / 1000;
              const time = seconds?.toFixed(1) + " sec";
              long_load_time.push({
                url: res.url || "undefined",
                time: time || "undefined",
                title: res.meta.title,
                status_code: res?.status_code,
              });
            }
            if (res.url_length > 100) {
              url_long.push({
                url: res.url || "undefined",
                title: res.meta.title,
                length: res?.url_length,
                status_code: res?.status_code,
              });
            }
          } else if (res.resource_type === "redirect") {
            resource_type_redirect += 1;
          } else if (res.resource_type === "broken") {
            resource_type_broken += 1;
          } else if (res.resource_type === "block") {
            resource_type_block += 1;
          }
        });

      setSeo_Descovered(
        low_word_count.length +
          dup_meta_desc.length +
          dup_title_tag.length +
          no_title_Tags.length +
          with_h1.length +
          with_broken.length +
          without_meta.length +
          with_title_too.length +
          with_title_short.length +
          poorly_format.length +
          doc_not_decl.length +
          long_load_time.length +
          url_long.length +
          short_desc?.length +
          long_desc?.length +
          duplicate_h1_tags?.length +
          same_h1_and_title_tags?.length +
          conanical_issue?.length +
          no_favicon?.length +
          no_image_alt?.length +
          no_image_title?.length
      );
      setAuditLoader(false);
    }
  }, [auditData]);

  const getCurrentCountryDetails = () => {
    if (usercurrentprojectlocation?.length === 0) return;
    const curr_proj = usercurrentprojectlocation?.[0];
    const loc_name = curr_proj?.location_name.split(",").pop();
    const data = countryList?.filter((item) => {
      return item.location_name === loc_name;
    });
    return data?.[0]?.location_flag;
  };

  const history_list = backlinkData.data?.data?.[0]?.history_list || [];
  const htmlItem = auditData?.[0]?.items?.find(
    (item) => item.resource_type === "html"
  );

  const domain_data_card = [
    {
      title: t("dashboard.domain_card.domain_rank"),
      value: domainAuthority,
      path: "/backlinks",
      loader: backlinkData.loading,
      status: domainAuthority != undefined,
    },
    {
      title: t("dashboard.domain_card.referring_domains"),
      value: history_list?.[history_list?.length - 1]?.referring_domains,
      path: "/backlinks",
      loader: backlinkData.loading,
      status: backlinkData.data?.length > 0,
    },
    {
      title: t("dashboard.domain_card.total_organic_keywords"),
      value: Math.floor(
        siteOverviewData?.data?.metrics?.[0]?.metrics?.organic?.count
      ),
      path: "/site-overview",
      loader: siteOverviewData.loading,
      status: siteOverviewData?.data?.length > 0,
    },
    {
      title: t("dashboard.domain_card.monthly_organic_traffic"),
      value: Math.floor(
        siteOverviewData?.data?.metrics?.[0]?.metrics?.organic?.etv
      ),
      path: "/site-overview",
      loader: siteOverviewData.loading,
      status: siteOverviewData?.data?.length > 0,
    },
    {
      title: t("dashboard.domain_card.backlinks"),
      value: backlinkData.data?.data?.[0]?.total_backlinks,
      path: "/backlinks",
      loader: backlinkData.loading,
      status: backlinkData.data?.length > 0,
    },
    {
      title: t("dashboard.domain_card.on_page_seo_score"),
      value: htmlItem?.onpage_score,
      path: "/site-audit",
      loader: auditLoader,
      status: auditData?.length > 0,
    },
    {
      title: t("dashboard.domain_card.seo_issues"),
      value: Seo_descovered,
      path: "/site-audit",
      loader: auditLoader,
      status: Seo_descovered != undefined,
    },
  ];

  const chart1_data = useMemo(() => {
    if (history_list?.length > 0) {
      const labels = history_list?.map((item) => item.month);
      const positionData = {
        new: history_list?.map((item) => item.new_refeering_domains),
        lost: history_list?.map((item) => {
          const num = item.lost_referring_domains;
          return num > 0 ? -num : num;
        }),
      };

      return {
        labels,
        datasets: chartType.chart1.label?.map((label) => ({
          label: t(label.name),
          data: positionData[label.key] || [], // dynamically pick dataset
          borderColor: label.color,
          pointRadius: 0,
          pointHoverRadius: 3,
          pointBorderColor: label.color,
          pointBackgroundColor: label.color,
        })),
      };
    } else {
      return [];
    }
  }, [history_list, chartType.chart1, t]);

  const chart2_data = useMemo(() => {
    if (siteOverviewData?.data?.metrics?.length > 0) {
      const data = siteOverviewData?.data?.metrics;
      const check = data.map(
        (res) => res.metrics.organic?.pos_1 + res.metrics.organic?.pos_2_3
      );
      if (removeUndefinedAndNaN(check)?.length === 0) return [];
      const labels = data
        .map((res) => `${months[res.month - 1]} ${res.year}`)
        .reverse();
      const positionData = {
        p1to3: data.map(
          (res) => res.metrics.organic?.pos_1 + res.metrics.organic?.pos_2_3
        ),
        p4to10: data.map((res) => res.metrics.organic?.pos_4_10),
        p11to50: data.map(
          (res) =>
            res.metrics.organic?.pos_11_20 +
            res.metrics.organic?.pos_21_30 +
            res.metrics.organic?.pos_31_40 +
            res.metrics.organic?.pos_41_50
        ),
        p51to100: data.map(
          (res) =>
            res.metrics.organic?.pos_51_60 +
            res.metrics.organic?.pos_61_70 +
            res.metrics.organic?.pos_71_80 +
            res.metrics.organic?.pos_81_90 +
            res.metrics.organic?.pos_91_100
        ),
      };
      return {
        labels,
        datasets: chartType.chart2.label?.map((label) => ({
          label: t(label.name),
          data: positionData?.[label.key]?.reverse() || [], // dynamically pick dataset
          backgroundColor: label.color,
        })),
      };
    } else {
      return [];
    }
  }, [siteOverviewData?.data, chartType.chart2, t]);

  const chart3_data = useMemo(() => {
    if (history_list?.length > 0) {
      const labels = history_list?.map((item) => item.month);
      const positionData = {
        backlinks: history_list?.map((item) => item.backlinks),
        referring_domains: history_list?.map((item) => item.referring_domains),
      };

      return {
        labels,
        datasets: chartType.chart3.label?.map((label) => ({
          label: t(label.name),
          data: positionData[label.key] || [], // dynamically pick dataset
          borderColor: label.color,
          pointRadius: 0,
          pointHoverRadius: 3,
          pointBorderColor: label.color,
          pointBackgroundColor: label.color,
        })),
      };
    } else {
      return [];
    }
  }, [history_list, chartType.chart3, t]);

  const chart4_data = useMemo(() => {
    if (siteOverviewData.data?.metrics?.length > 0) {
      const data = siteOverviewData.data?.metrics;
      const check = data.map((res) => res.metrics.organic?.etv);
      if (removeUndefinedAndNaN(check)?.length === 0) return [];
      const labels = data
        .map((res) => months[res.month - 1] + " " + res.year)
        .reverse();
      const positionData = {
        organic: data.map((res) => res.metrics.organic?.etv),
        paid: data.map((res) => res.metrics.paid?.etv),
      };
      return {
        labels,
        datasets: chartType.chart4.label?.map((label) => ({
          label: t(label.name),
          data: positionData[label.key]?.reverse() || [], // dynamically pick dataset
          backgroundColor: label.color,
          borderWidth: 0,
          borderRadius: 1,
          barPercentage: 1,
          categoryPercentage: 0.1,
          barThickness: 12,
        })),
      };
    } else {
      return [];
    }
  }, [siteOverviewData?.data, chartType.chart4, t]);

  const addQueryParam = (e, path) => {
    if (usercurrentprojectlocation?.length === 0) return;
    const curr_proj = usercurrentprojectlocation?.[0];
    const lastString = curr_proj?.location_name.split(",").pop(); // "India"
    const country = country_Language_Data?.data?.filter((country) => {
      return (
        country.location_name === lastString &&
        country?.location_type === "Country"
      );
    });

    const config = {
      domain: curr_proj?.weburl,
      loc_name: country ? country?.[0]?.location_name : "United States",
      loc_code: country ? country?.[0]?.location_code : 2840,
      loc_flag: country
        ? country?.[0]?.flag
        : "https://flagsapi.com/US/flat/24.png",
      language_name: country
        ? country?.[0]?.available_languages?.[0]?.language_name
        : "English",
      language_code: country
        ? country?.[0]?.available_languages?.[0]?.language_code
        : "en",
    };
    sessionStorage.setItem("lastdomainname", config?.domain);

    if (path === "/backlinks") {
      dispatch({ type: "BACKLINKDOMAIN", payload: config?.domain });
      navigate("/backlinks");
    } else if (path === "/site-overview") {
      ZustandStore.setState({
        worldwide_domain: null,
        site_overview_worldwide: {
          domain: "",
          data: [],
        },
        site_overview_backlink_data: [],
        site_overview_page_data: [],
      });
      const domainLocation = {
        location_name: config?.loc_name,
        location_code: config?.loc_code,
        location_flag: config?.loc_flag,
        language_code: config?.language_code,
        language_name: config?.language_name,
        show: "",
      };
      sessionStorage.setItem("domainCountry", JSON.stringify(domainLocation));
      sessionStorage.setItem("lastdomainname", config?.domain);
      navigate(`/site-overview`);
    } else {
      navigate(path);
    }
  };

  return (
    <main className="main-pd rank-tracking-container dashboard-app-container">
      <section className="project-selection">
        <div className="row p-0">
          <div className="col-lg-12 col-md-12">
            <div className="project-container">
              <div className="project-header">
                <h1 className="">{t("dashboard.title")}</h1>
              </div>
              <p>{t("dashboard.description")}</p>

              <div className="row">
                <div className="col-12 col-md-5">
                  <ProjectList />
                </div>
                <div className="col-12 col-md-7 d-flex align-items-center p-md-0">
                  <div className="d-flex justify-content-center align-items-center mt-2 mt-md-0 mt-lg-0 h-100 gap-2">
                    <AddProject />
                    {!Is_organization && (
                      <SemButton
                        icon={<DeleteIcon />}
                        onClick={() => setdeleteAlert(true)}
                        name={t("dashboard.delete_project_button.title")}
                        title={t("dashboard.delete_project_button.title")}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="domian-data-card container-scroll">
        {domain_data_card?.map((item, index) => {
          return (
            <div
              key={index}
              className={
                !item?.loader
                  ? "px-3 py-2 domain-card position-relative"
                  : "domain-card"
              }
            >
              {!item?.loader ? (
                !item?.loader &&
                handleNaNAndUndefined(item?.value) &&
                !item?.status ? (
                  <>
                    {item?.path === "/backlinks" ||
                    item?.path === "/site-overview" ? (
                      <>
                        <h1 className="font-medium heading-xs">
                          {item?.title}
                        </h1>
                        <SemButton
                          name="check"
                          size="m"
                          color="#365486"
                          wMin="70"
                          hMin="30"
                          onClick={(e) => addQueryParam(e, item?.path)}
                        >
                          {t("dashboard.domain_card.check_button")}
                        </SemButton>
                      </>
                    ) : (
                      <>
                        <h1 className="font-medium heading-xs">
                          {item?.title}
                        </h1>
                        <Link to={item?.path}>
                          <SemButton
                            name={t("dashboard.domain_card.check_button")}
                            size="m"
                            color="#365486"
                            wMin="70"
                            hMin="30"
                          />
                        </Link>
                      </>
                    )}
                  </>
                ) : (
                  <div
                    onClick={(e) => addQueryParam(e, item?.path)}
                    className="point"
                  >
                    <h1 className="font-medium heading-xs">{item?.title}</h1>
                    <h3 className="font-bolder heading-xlarge mb-0 d-flex align-items-center justify-content-center">
                      {item?.value == "undefined"
                        ? "0"
                        : formatNumberWithSymbols(item?.value) || "0"}
                      {item?.title === "Organic Monthly Traffic" ||
                      item?.title === "Total Organic Keywords" ? (
                        <img
                          src={getCurrentCountryDetails()}
                          alt="flag"
                          className="ms-3"
                          style={{ width: "20px", objectFit: "contain" }}
                        />
                      ) : null}
                    </h3>
                  </div>
                )
              ) : (
                <div className="rank-card-loader">
                  <Player
                    src={spinLoaderAnimation}
                    className="player"
                    loop
                    autoplay
                    speed={3}
                    style={{ width: "100px" }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </section>

      <section className="keyword-ranking-data">
        <div
          className={
            RankDownPercent === 0 || showLoader || RankMovedup === null
              ? "keyword-rank-chart blur-card"
              : "keyword-rank-chart"
          }
        >
          <PieChartForRank />
          <div className="key-rank-card-up-down">
            <div
              className={
                showLoader || RankMovedup === null
                  ? "card-up blur-card"
                  : "card-up"
              }
            >
              <h1 className="font-bold heading-small mb-0">
                {" "}
                {t("dashboard.keyword_rank_chart.keywords.title")}
              </h1>
              <h1 className="font-bold heading-small">
                {" "}
                {t("dashboard.keyword_rank_chart.keywords.moved_up")}
              </h1>
              <span className="d-flex align-items-center">
                <RankIcon />
                <h2 className="font-bold heading-xlarge ms-2">{RankMovedup}</h2>
              </span>
            </div>
            <div
              className={
                showLoader || RankMovedup === null
                  ? "card-down blur-card"
                  : "card-down"
              }
            >
              <h1 className="font-bold heading-small mb-0">
                {" "}
                {t("dashboard.keyword_rank_chart.keywords.title")}
              </h1>
              <h1 className="font-bold heading-small">
                {t("dashboard.keyword_rank_chart.keywords.moved_down")}
              </h1>
              <span className="d-flex align-items-center">
                <RankIcon />
                <h2 className="font-bold heading-xlarge ms-2">
                  {RankMovedDown}
                </h2>
              </span>
            </div>
          </div>
        </div>

        <Suspense
          fallback={
            <div className="view-google-data">
              <Spinner />
            </div>
          }
        >
          <DashboardGoogleData />
        </Suspense>
      </section>

      <section className="chart-container">
        <div className="row gy-4 mt-3">
          <div
            className="col-12 col-lg-6"
            onClick={(e) => addQueryParam(e, "/backlinks")}
          >
            <ChartWrapper
              chart={chartType.chart1}
              key={"New & Lost Referring Domains"}
            >
              <NegativeStackedBarChart data={chart1_data} />
              {chart1_data?.length === 0 && <BlurCard useBtn={true} />}
            </ChartWrapper>
          </div>
          <div
            className="col-12 col-lg-6"
            onClick={(e) => addQueryParam(e, "/site-overview")}
          >
            <ChartWrapper
              chart={chartType.chart2}
              key={"SEO Keywords Distribution"}
            >
              <GroupedBarsChart data={chart2_data} />
              {chart2_data?.length === 0 && <BlurCard useBtn={true} />}
            </ChartWrapper>
          </div>
          <div
            className="col-12 col-lg-6"
            onClick={(e) => addQueryParam(e, "/backlinks")}
          >
            <ChartWrapper chart={chartType.chart3} key={"Backlinks Over Time"}>
              <LineChart data={chart3_data} />
              {chart3_data?.length === 0 && <BlurCard useBtn={true} />}
            </ChartWrapper>
          </div>
          <div
            className="col-12 col-lg-6"
            onClick={(e) => addQueryParam(e, "/site-overview")}
          >
            <ChartWrapper chart={chartType.chart4} key={"Total Traffic"}>
              <GroupedBarsChart data={chart4_data} />
              {chart4_data?.length === 0 && <BlurCard useBtn={true} />}
            </ChartWrapper>
          </div>
        </div>
      </section>

      {deleteAlert ? (
        <AreYousure
          callback={Do_Project_Delete}
          title={t("dashboard.delete_alert")}
        />
      ) : null}
    </main>
  );
};
export default Home;
